import { Canvas } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import { SecondFloorModel } from "../components/models/SecondFloorModel";
import { Environment } from '@react-three/drei'
import CampusHDR from '../img/hdri/spaichingen_hill_1k.hdr';
import { Suspense } from "react";
import LoadingSpinner from "../components/LoadingSpinner.js";
import { useMediaQuery } from "@uidotdev/usehooks";

export default function SecondFloor() {

  const isLargeDevice = useMediaQuery("(min-width : 1024px)");
  const isMediumDevice = useMediaQuery("(min-width : 768px)");
  const isExtraLargeDevice = useMediaQuery("(min-width : 1280px)");

  return (
    <div
      id="second-floor"
      className="flex flex-col w-[95%] lg:w-4/6 mx-auto h-[calc(100vh-3rem-59.23px)]"
    >
      <div className="flex flex-col lg:flex-row h-full">
        <div className=""></div>

        <div className="h-full w-full flex">
          <Canvas camera={{ position: [8, 6, 8], fov: 30 }}>
            <Suspense fallback={<LoadingSpinner />}>

            <ambientLight intensity={1} />
            <OrbitControls
              autoRotate={true}
              enableZoom={true}
              enableRotate={true}
              enablePan={true}
            />
            <SecondFloorModel scale={isExtraLargeDevice ? 0.2: isLargeDevice ? 0.2 : isMediumDevice ? 0.2 : 0.14} />
            <Environment files={CampusHDR} />
            </Suspense>
          </Canvas>
        </div>
      </div>
    </div>
  );
}
